<template>
  <div class="container d-flex fd-column SECTION">
    <div class="h3 text-bold p-x-1:mo p-b-2">
      <div>{{content.title}}</div>
    </div>
    <div class="d-flex w-100 fd-column:mo flex-0-1 STEP-SECTION" >
      <div
          v-for="(step, index) in content.steps"
          :key="index"
          class="STEP"
      ><how-it-works-step
          :step= step />
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import HowItWorksStep from './components/HowItWorksStep';

export default {
  name: 'how-it-works',
  components: {
    HowItWorksStep,
  },

  computed: {
    ...mapGetters('homepage/contentful', [
      'customerHomePage',
    ]),
    content () {
      return this.customerHomePage.howItWorksSection;
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@homeservices/design-kit/tools";
  .SECTION {
    margin-bottom: 8 * $unit;
  }
  .STEP-SECTION {
    display: flex;
    flex: 1 1 auto;
  }
  .STEP {
    @include desktop () {
      margin-right: 16px;
    }
  }
  .STEP:nth-child(3) {
      margin-right: 0px;
    }
</style>
